import React from "react";
import { IPath, PATH } from "../../router/path"
import { ReactElement } from "react";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import AppsIcon from "@mui/icons-material/Apps";
import ArchitectureIcon from "@mui/icons-material/Architecture";
import LanguageIcon from "@mui/icons-material/Language";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import DnsIcon from "@mui/icons-material/Dns";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import CloudIcon from "@mui/icons-material/Cloud";
import Book from '@mui/icons-material/Book';
import Houseboat from '@mui/icons-material/Houseboat';
import { UserRole } from "../../models/types/graphql-global-types";

export interface IMenuItem extends IPath {
  title: string;
  icon: ReactElement;
  action?: boolean;
  children?: IMenuItem[];
}

const iconStyle = {
  color: "white",
  height: 20,
  width: 20,
};

export const menuItems: IMenuItem[] = [
  {
    ...PATH.SIMPLE_CATALOG,
    title: "navigation.home",
    icon: <AppsIcon style={iconStyle} />,
    roles: [
      UserRole.ADMIN,
      UserRole.GUEST,
      UserRole.UNDEFINED,
      UserRole.READ_ONLY,
    ],
  },
  {
    ...PATH.CATALOG,
    title: "navigation.adminHome",
    icon: <AppsIcon style={iconStyle} />,
    roles: [UserRole.ADMIN],
  },
  {
    ...PATH.DIGIDO,
    title: "navigation.digido",
    icon: <AppsIcon style={iconStyle} />,
    roles: [UserRole.ADMIN, UserRole.DIGIDO],
  },
  {
    ...PATH.INFO,
    title: "navigation.info",
    icon: <FormatListNumberedIcon style={iconStyle} />,
    roles: [UserRole.ADMIN],
  },
  {
    ...PATH.ARCHITECTURE,
    title: "navigation.architecture",
    icon: <ArchitectureIcon style={iconStyle} />,
    roles: [UserRole.ADMIN],
  },
  {
    ...PATH.WEBSITES,
    title: "navigation.websites",
    icon: <LanguageIcon style={iconStyle} />,
    roles: [UserRole.ADMIN],
  },
  {
    ...PATH.CENTRALGATEWAY,
    title: "navigation.gateways",
    icon: <VpnKeyIcon style={iconStyle} />,
    roles: [UserRole.ADMIN],
  },
  {
    ...PATH.ATGOLORSDATAAPI,
    title: "navigation.atgolorsdataapi",
    icon: <DnsIcon style={iconStyle} />,
    roles: [UserRole.ADMIN],
  },
  {
    ...PATH.HANDELSAPP,
    title: "navigation.handelsapp",
    icon: <ShowChartIcon style={iconStyle} />,
    roles: [UserRole.ADMIN],
  },
  {
    ...PATH.AZURE,
    title: "navigation.azure",
    icon: <CloudIcon style={iconStyle} />,
    roles: [UserRole.ADMIN],
  },
  {
    id: "urlaub-backup",
    title: "navigation.urlaubs_backup",
    icon: <Houseboat style={iconStyle} />,
    roles: [UserRole.ADMIN],
    children: [
      {
        ...PATH.DUNJA_NOTES,
        id: "dunja-notes",
        route: "urlaub-backup/dunja",
        title: "navigation.dunja_notes",
        icon: <Book style={iconStyle} />,
        roles: [UserRole.ADMIN],
      },
      {
        ...PATH.ANDREAS_NOTES,
        id: "andreas-notes",
        route: "urlaub-backup/andreas",
        title: "navigation.andreas_notes",
        icon: <Book style={iconStyle} />,
        roles: [UserRole.ADMIN],
      },
    ],
  },
];
